import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Text, xcss } from '@atlaskit/primitives';

import { useIsDisabledContext } from '../../../controllers/disabled-context';

type PanelSubheaderProps = {
	children: ReactNode;
	showUpdatedStyles?: boolean;
};

const panelSubheaderStyles = xcss({
	color: 'color.text.subtlest',
});

const panelSubheaderDisabledStyles = xcss({
	color: 'color.text.disabled',
	':hover': {
		cursor: 'not-allowed',
	},
});

export const PanelSubheader = ({
	children,
	showUpdatedStyles = false,
}: PanelSubheaderProps): React.JSX.Element => {
	const isDisabled = useIsDisabledContext();

	return (
		<Box xcss={[panelSubheaderStyles, isDisabled && panelSubheaderDisabledStyles]}>
			<Text
				size={showUpdatedStyles ? 'medium' : 'small'}
				weight={showUpdatedStyles ? 'regular' : 'bold'}
				color={showUpdatedStyles ? 'color.text' : 'inherit'}
			>
				{children}
			</Text>
		</Box>
	);
};
